<template>
    <div class="vx-row drop5" style="flex-wrap: nowrap;">
        <!-- <div class="w-full sm:w-3/5">
            <vx-card title="스마트링크 설정" class="mb-6">
                <div class="vx-row w-full mb-6 ">
                    <div class="vx-col w-full">
                        <span style="margin-right: 10px;">배경 컬러</span>
                        <colorPicker v-model="colors" />
                        <span style="margin:0 10px;">아이콘+텍스트 컬러</span>
                        <colorPicker v-model="colors2" />
                    </div>
                    <div class="vx-col vx-row sm:w-1/3  w-full ">
                        <div>
                            텍스트 소개
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/6 w-full items-center">
                        영상주소
                    </div>
                    <div class="vx-col vx-row sm:w-1/3 items-center w-full ">
                        
                    </div>
                </div>
            </vx-card>
        </div>
        <div class="w-full sm:w-2/5" style="margin-left: 30px;">
            <vx-card title="미리보기" class="mb-6">
                <div class="vx-row w-full mb-6 ">
                    <div class="smartPreview">

                    </div>
                </div>
            </vx-card>
        </div> -->
        <file-upload
            class="w-full "
            input-id="file5"
            :post-action='fileUrl'
            accept="audio/wav"
            :multiple="false"
            :directory="false"
            drop=".drop5"
            :drop-directory="true"
            :add-index="false"
            v-model="files5"
            :headers="headers"
            @input-filter="inputFileUpload5"
            ref="upload5"
            v-show="files5.length == 0"
            >
            <div class="flex items-center justify-center" style="width:100%; height:200px; background-color: none;" >
                <span v-if="files5.length == 0">
                    <i translate="translate" class="material-icons notranslate" style="display: block; margin-bottom: 10px;"> 
                    cloud_upload </i> File Upload
                </span>
                <span v-if="files5.length> 0 && files5[0].progress != '100.00'">{{files5[0].progress}}%</span>
                <div v-if="files5.length> 0 && files5[0].progress == '100.00'">
                    {{files5[0].response[0].display_name}}
                    <vs-button  @click="removeDolbyFile(indextr)"color="danger" size="small">삭제</vs-button>
                </div>
            </div>
            
        </file-upload>
    </div>
    
</template>
 
<script>

import Vue from 'vue'
import * as mmb from 'music-metadata-browser';
// import { exiftool } from 'exiftool-vendored'
export default {
    data () {
        return {
            fileUrl: `${process.env.VUE_APP_API_URL}/file`,
            headers: {
                Authorization: `Bearer ${localStorage.getItem('srAccessToken')}`,
                'Access-Control-Allow-Origin': '*',
            },
            colors : '' ,
            colors2 : '' ,
            file5: {
                id :null,
                preview : ''
            },
            files5 : []
        }
    },
    watch: {
    
    },
    created(){
    },
    mounted(){
        this.$nextTick(() =>{
            this.callList()
        })
    },
    methods: {
        fileChange(e){
            
            let file = e.target.files[0];
            const video = document.createElement('video')
            video.addEventListener('loadedmetadata', event => {
                console.log(event)
                console.log(video.videoWidth, video.videoHeight)
            });
            video.src = URL.createObjectURL(file);
            // this.getMetadata(file.path)
        },
        inputFileUpload5(newFile, oldFile) {
      
            if (newFile && !oldFile) {
                // add
                if(newFile.type.indexOf('wav') < 0 ){
                
                
                
                this.$refs.upload5.active = false
                setTimeout(() => {
                    this.files5 = []
                    this.$refs.upload5.remove(newFile)  
                }, 0);
                this.$forceUpdate()
                this.alert({msg:'오디오(wav) 파일만 가능합니다.'});
                return prevent()
                }
                
            
                let file = newFile.file
                let reader = new FileReader
                this.loadingShow();
                reader.onload = e => {
                    console.log(e)
                    const dd = this.getMetadata(file)
                    dd.then(result =>{
                        if(result.format.numberOfChannels > 2){
                        this.$refs.upload5.active = true
                        this.file5.preview = e.target.result
                        }else{
                        this.alert({msg:'Dolby 음원이 아닙니다.'})
                        this.$refs.upload5.remove(newFile)
                        this.files5 = []
                        this.loadingHide();
                        return false
                        }
                    }).catch(e=>{console.log(e)})
                }
                reader.readAsDataURL(file)
            }
            if (newFile && oldFile) {
                // update
                if(Array.isArray(newFile.response)){
                this.file5 ={
                    ...this.file5,
                    ...newFile.response[0]
                }
                }
                if(newFile.progress == '100.00' ){
                this.loadingHide()
                }
                if(newFile.progress == '0.00' ){
                }
            }
            
            if (!newFile && oldFile) {
                // remove
                
            }
            },
            async getMetadata(file){
            console.log(`Parsing file "${file.name}" of type ${file.type}`);

            return mmb.parseBlob(file, {native: true}).then(metadata => {
                console.log(`Completed parsing of ${file.name}:`, metadata);
                return metadata;
            })
            },
            removeDolbyFile(){
            this.loadingShow();
            console.log(this.trackDetail)
            if(this.trackDetail.dolbyatmos_id){
                const payload = {
                album_id : this.$route.params.id,
                track_id : this.trackDetail.id,
                }
                this.$store.dispatch("DELETE_DOLBY_FILE", payload)
                .then(result => {
                this.loadingHide();
                this.noti('삭제되었습니다.')
                this.datacall()
                this.files5 = []
                this.file5 = {
                    id :null,
                    preview : ''
                }
                this.trackDetail.dolbyatmos_id = null
                }).catch(error=>{
                this.loadingHide();
                switch(error.response.data.code) {
                    default:
                    this.alert({msg:error})
                    break;
                }
                })
            }else{
                const payload = {
                id : this.files5[0].response[0].id
                }
                this.$store.dispatch("DELETE_ONLY_FILE", payload)
                .then(result => {
                this.loadingHide();
                this.noti('삭제되었습니다.')
                this.files5 = []
                this.file5 = {
                    id :null,
                    preview : ''
                }
                this.trackDetail.dolbyatmos_id = null
                }).catch(error=>{
                this.loadingHide();
                switch(error.response.data.code) {
                    default:
                    this.alert({msg:error})
                    break;
                }
                })
                this.files5 = []
                this.file5 = {
                id :null,
                preview : ''
                }
            }
            
        },
    },
    mounted () {
        
    },
    
    destroyed () {
    }
}

</script>
